import React, { useCallback, useEffect, useState } from 'react';
import service from '../../../services/usuarios';
import Listagem from '../crud/Listagem';
import { actions as actionSite } from './../../../redux/actions/site';
import { useDispatch } from 'react-redux';
import { downloadFile } from '../../../utils/file';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
const Usuarios = props => {
    const dispatch = useDispatch();
    
    const extrairItinerarios = async () => {
        dispatch(actionSite.setLoadingMsg("Processando..."));

        const headers = ["Itinerário;Nome;Telefone;Endereço;Bairro;CEP"];
        const rows = await service.get('itinerarios');
        // Convert rows data to a csv
        let rowsCSV = rows.reduce((acc, row) => {
            let { itinerario, nome, telefone, endereco, bairro, cep } = row;
            
            acc.push([itinerario, nome, telefone, endereco, bairro, cep].join(";"));
            return acc;
        }, []);

        downloadFile({
            data: [...headers, ...rowsCSV].join("\n"),
            fileName: "itinerarios.csv",
            fileType: "text/csv",
        });
        dispatch(actionSite.setLoadingMsg(""));
    }

	const extrairItinerariosFull = async () => {
        dispatch(actionSite.setLoadingMsg("Processando..."));

        const headers = ["Itinerário;Nome;Telefone;Endereço;Bairro;CEP"];
        const rows = await service.get('itinerarios-full');
        // Convert rows data to a csv
        let rowsCSV = rows.reduce((acc, row) => {
            let { itinerario, nome, telefone, endereco, bairro, cep } = row;
            
            acc.push([itinerario, nome, telefone, endereco, bairro, cep].join(";"));
            return acc;
        }, []);

        downloadFile({
            data: [...headers, ...rowsCSV].join("\n"),
            fileName: "itinerariosFull.csv",
            fileType: "text/csv",
        });
        dispatch(actionSite.setLoadingMsg(""));
    }

    const extrairUltimasVendas = async () => {
        dispatch(actionSite.setLoadingMsg("Processando..."));

        // const headers = ["Nome;Catálogos"];
        const rows = await service.get('ultimas-vendas');
        
        rows.sort((a,b)=>{
					if (a.itinerario === b.itinerario){
						return a.usuario < b.usuario ? -1 : 1
					} else {
						return a.itinerario < b.itinerario ? -1 : 1
					}
				});

				var win = window.open("", "_blank");

				
				const cols = rows.map(test=>{
					return {
						table: {
							heights: [40,40, 10],
							widths: [170],
							body: [
								[{text:test.usuario, alignment:'center', bold:true, fontSize:12}], 
								[{text:test.catalogos.join(", "), alignment:'center', fontSize:10}],
								[{text:test.itinerario,alignment:'center', fontSize:10}]
							],
						},
						layout: {
							hLineWidth: function (i, node) {
								return 0;
							},
							vLineWidth: function (i, node) {
								return 0;
							},
						},
					}
				});

				const linhas = [];
				let n=0;
				let linha = [];
				while(cols.length > 0){
					const col = cols.shift();
					if(n > 0 && n % 18 === 0){
						col.pageBreak = 'after';
					}
					linha.push(col);
					n++;
					if( n > 0 && n % 3 === 0){
						linhas.push(linha);
						linha=[];
					}
				}

				if(linha.length > 0){
					if (linha.length < 3){
						const diff = 3 - linha.length;
						for(let x=0; x < diff; x++){
							linha.push("");
						}
					}
					linhas.push(linha);
				} 
					
				
				const docDefinition = {
					pageSize: "A4",

					pageOrientation: "portrait",
					pageMargins: [ 10,10,10,10 ],
					content: [
						{
							style: "tableExample",
							table: {
								body: [
									...linhas
								],
							},
							layout: {
								// hLineWidth: function (i, node) {
								//   return i === 0 || i === node.table.body.length ? 2 : 1;
								// },
								// vLineWidth: function (i, node) {
								//   return i === 0 || i === node.table.widths.length ? 2 : 1;
								// },
								hLineColor: function (i, node) {
									return "lightgray";
								},
								vLineColor: function (i, node) {
									return "lightgray";
								},
								hLineStyle: function (i, node) {
									if (i === 0 || i === node.table.body.length) {
										return null;
									}
									return { dash: { length: 4, space: 4 } };
								},
								vLineStyle: function (i, node) {
									if (i === 0 || i === node.table.widths.length) {
										return null;
									}
									return { dash: { length: 4 } };
								},
							},
						},
					],
					styles: {
						header: {
							fontSize: 18,
							bold: true,
						},
						subheader: {
							fontSize: 16,
							bold: true,

						},
						tableExample: {

						},
						tableHeader: {
							bold: true,
							fontSize: 13,
							color: "black",
						},
					},
					defaultStyle: {
						// alignment: 'justify'
					},
				};
				pdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs).open({}, win);

        dispatch(actionSite.setLoadingMsg(""));
    }

    const config = {
        columns: [
            { label: "Nome", field: "nome" },
            { label: "E-mail", field: "email" },
            { label: "Bairro", field: "bairro", filter: { field: 'enderecos', condition: { field: 'tipo', value: 'residencial' } } },
            { label: "Cidade", field: "cidade", filter: { field: 'enderecos', condition: { field: 'tipo', value: 'residencial' } } },
			{ label: "Recusado", field: "recusado", convert: 'toSimNao' },
        ],
        pagination: {
            limit: 20
        },
        sort: 'nome',
        search: [
            { label: 'Nome', field: 'nome', operators: ['contains', 'not_contains'] },
            { label: 'Telefone', field: 'telefone', operators: ['contains', 'not_contains'] },
            { label: 'Bairro', field: 'bairro', operators: ['contains', 'not_contains'] },
            { label: 'Cidade', field: 'cidade', operators: ['contains', 'not_contains'] },
            { label: 'UF', field: 'uf', operators: ['contains','not_contains'] }
        ],
        extraButtons:[
            {label:"Itinerários TODOS (CSV)", color:"azul", action:extrairItinerariosFull},
			{label:"Itinerários (CSV)", color:"azul", action:extrairItinerarios},
			{label:"Últimas vendas Etiquetas (PDF)", color:"verde", action:extrairUltimasVendas, icon: faFilePdf}
        ]
    }

    const [users, setUsers] = useState({ rows: [], total: 0 });
    const [loadingList, setLoadingList] = useState(false);

    const getList = useCallback(async (params, skip) => {
        setLoadingList(true);
        params.push({ field: "grupo", operator: "equal", value: "6025825722f01d0009a25b77" });
        // params.push({ field: "processado", operator: "equal", value: true });
        // params.push({ field: "recusado", operator: "equal", value: false });
		params.push({ field: "status", operator: "equal", value: 3 });
        const result = await service.getList({ params, sort: config.sort }, skip, config.pagination.limit);
        setLoadingList(false);
        setUsers(result);
    }, [config.pagination.limit, config.sort]);

    const upsert = async (obj, id) => {
        setLoadingList(true);
        const result = await service.upsert(obj, id);
        setLoadingList(false);
        return result;
    }

    

    // useEffect(() => {
    //     getList([], 0);
    // }, [getList]);

    return (
        <>
            <Listagem registros={users} service={{ getList, upsert }} config={config} loadingList={loadingList} rota="usuarios" />
        </>
    )
};

export default Usuarios;